// extracted by mini-css-extract-plugin
export var badge = "index-module--badge--39BDd";